<template>
  <div class="moblieContent" :style="{ '--theme-color': background }">
    <div class="moblieBox" ref="moblieBox">
      <div class="topInfo" ref="topInfo">
        <div class="div_shown_close_button" v-if="Boolean(showReturnButton)">
          <div class="div_close_button" @click="showCloseDialog">
            <span class="close-icon">✕</span>
          </div>
        </div>
        <div class="title">{{ $t("common.checkout") }}</div>
        <!-- <div class="changeLangBtn" @click="changeL(languageTitle)">
          <i></i>
          {{ languageTitle }}
        </div> -->
        <!-- 切换语言 -->
        <div class="div_select_right">
          <div class="mobile-language-selector">
            <div
              class="selected-language"
              @click="showLanguageOptions = !showLanguageOptions"
            >
              {{ languageTitle }} <i class="el-icon-arrow-down"></i>
            </div>
            <div class="language-options" v-if="showLanguageOptions">
              <div
                v-for="item in language"
                :key="item.value"
                class="language-option"
                :class="{ active: languagekey === item.value }"
                @click="handleLanguageChange(item.value, item.text)"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="amountInfo">
          <div class="subscription-card">
            <div class="header-row" v-if="!subError">
              <div class="success-icon" :style="setCheckTheme()">
                <span class="check">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4.24219"
                      y="14.1433"
                      width="20"
                      height="6"
                      rx="3"
                      transform="rotate(45 4.24219 14.1433)"
                      fill="white"
                    />
                    <rect
                      x="32.5273"
                      y="14.1433"
                      width="26"
                      height="6"
                      rx="3"
                      transform="rotate(135 32.5273 14.1433)"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
              <div class="subscription-title">
                {{ $t("common.subscriptionReceived") }}
              </div>
            </div>
            <div class="header-row" v-if="subError">
              <img v-if="subError" src="../../assets/pc/fork_red.svg" alt />
              <div class="subscription-title">{{ failStatusInfo }}</div>
            </div>
            <div class="countdown" v-if="!subError">
              <span>{{ $t("common.leftTime") }}</span>
              <span class="time" :style="setCountdownTheme()">{{
                countDownList
              }}</span>
              <!-- <span>{{ $t('common.rightTime') }}</span> -->
            </div>
          </div>
        </div>
        <!-- <div class="botLine"></div> -->
      </div>

      <!-- 间隔线 -->
      <!-- <div class="line"></div> -->

      <!-- mol 容器 -->
      <!-- <div id="molpay_ebanking_fpx_MY-container"></div> -->

      <div class="fffContainer" ref="fffContainer" v-if="!subError">
        <div class="changeCardBox">
          <div class="current-payment-section">
            <div class="payment-card">
              <div class="card-content">
                <div class="card-left">
                  <div class="payment-method-label">
                    {{ $t("common.paymentMethod") }}
                  </div>
                  <div class="payment-method-value">
                    {{ $t("common.cards") }}
                  </div>

                  <div class="card-holder-label">
                    {{ $t("common.cardHolder") }}
                  </div>
                  <div class="card-holder-value">
                    {{ currentPaymentInfo.cardHolder }}
                  </div>
                </div>

                <div class="card-right">
                  <div class="card-brand-label">
                    {{ $t("common.cardBrand") }}
                  </div>
                  <div class="card-brand-value">
                    {{ currentPaymentInfo.cardBrand }}
                  </div>

                  <div class="card-number-label">
                    {{ $t("common.cardNumber") }}
                  </div>
                  <div class="card-number-value">
                    {{ currentPaymentInfo.cardNumber }}
                  </div>
                </div>
              </div>

              <div class="subscription-info">
                <div class="subscription-title">
                  {{ $t("common.activeSubscription") }}
                </div>

                <div class="subscription-info-content">
                  <div class="subscription-details">
                    <div class="subscription-name">
                      {{ currentPaymentInfo.subscriptionName }}
                    </div>
                    <div class="subscription-price">
                      {{ currentPaymentInfo.subscriptionPrice }}
                    </div>
                  </div>

                  <div class="next-payment">
                    <span class="next-payment-label"
                      >{{ $t("common.nextPayment") }}:</span
                    >
                    <span class="next-payment-date">{{
                      currentPaymentInfo.nextPaymentDate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 支付方式 -->
        <div
          class="payMethod"
          v-if="
            !subError &&
              goodInfo.payWayConfigList &&
              goodInfo.payWayConfigList.length > 0
          "
        >
          <div class="title">{{ $t("common.paySubMethods") }}</div>
          <div class="payAll">
            <van-radio-group v-model="checkoutValue">
              <van-cell-group :border="false">
                <div
                  v-for="(item, index) in goodInfo.payWayConfigList"
                  :key="index"
                >
                  <div
                    v-if="
                      (item.payWayCode == 9 && supportsApplePay()) ||
                        item.payWayCode != 9
                    "
                  >
                    <van-cell
                      :border="false"
                      @click="
                        selectPay(
                          item.curPayProductData.productCode,
                          item.payWayCode
                        )
                      "
                    >
                      <template #title>
                        <div class="payPart clearfix">
                          <i class="l">
                            <img :src="item.logoUrl" />
                          </i>
                          <div class="text l">
                            <van-cell
                              center
                              :title="item.payWayName"
                              lable="asdasd"
                            />
                          </div>
                        </div>
                      </template>
                      <template #right-icon>
                        <van-radio
                          class="radioBox"
                          :name="item.curPayProductData.productCode"
                        />
                      </template>
                    </van-cell>
                  </div>
                  <!-- 如果是选中FPX支付 -->
                  <!-- <div v-if="item.payProduct == 46 && checkoutValue == 46">
                    <p class="mol_tip" v-if="fpxPaymentMethod">{{fpxPaymentMethod.issuer}}</p>
                </div> -->
                  <!-- <p
                    class="tip"
                    v-if="
                      item.curPayProductData.productCode === 31 && showStripe
                    "
                  >
                    请使用微信扫一扫付款。注：请勿在微信内长按识别二维码，或扫描本地相册的二维码。
                  </p> -->
                </div>
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>
        <div
          class="payMethod"
          v-if="
            !subError &&
              goodInfo.payWayConfigList &&
              goodInfo.payWayConfigList.length == 0
          "
        >
          <div class="resultText">
            <div class="result-icon">
              <img src="../../assets/pc/fork_red.svg" alt="错误" />
            </div>
            <div class="result-message">
              {{ $t("common.noPayWay") }}
            </div>
          </div>
        </div>
      </div>
      <!-- 支付失败弹窗 -->
      <van-dialog
        class="dialogBox"
        v-model="dialogShow"
        :confirmButtonText="$t('moblie.modalConfirm')"
        :confirmButtonColor="getConfirmButtonColor()"
        :overlay="true"
        @confirm="closeDialog"
      >
        <img
          :src="require('../../assets/mobile/' + srcPath + '.png')"
          width="160"
        />
        <p>{{ failStatusInfo }}</p>
      </van-dialog>
    </div>
    <!-- test -->
    <!-- <div ref="cardContainer" id="AirwallexCard"></div>
<button id="submit" @click="handlePayment">Submit</button> -->
    <!-- test -->
    <!-- 支付按钮 -->
    <div
      class="payBtnBox"
      v-if="
        !subError &&
          goodInfo.payWayConfigList &&
          goodInfo.payWayConfigList.length > 0
      "
    >
      <div class="payBtn" @click="goPay" :style="setBtnTheme()">
        {{ $t("common.confirm") }}
        <!-- <span style="margin-left:0.08rem">{{ goodInfo.currencySymbol }}</span>
        <span :style="setAmountTheme()">{{ goodInfo.totalFee }}</span> -->
      </div>
    </div>
    <!-- paynow支付 -->
    <van-action-sheet
      v-if="isShowPaynowSheet && !subError"
      v-model="isShowPaynowSheet"
      class="paynow-action-sheet"
    >
      <div class="header">
        <div class="div_left">
          <img :src="logoInfo.path" alt width="56" />
          {{ logoInfo.name }}
        </div>
        <div class="div_right" @click="closePayResult">
          <span></span>
        </div>
      </div>
      <div class="centerContent">
        <div ref="qrcodeRef"></div>
        <div class="botText" style="margin-top:14px;">
          {{ $t("moblie.paynowScanCodeNormal1") }}
          <span>{{ $t("moblie.paynowScanCodeApp") }}</span>
          {{
            languageTitle == "English" ? $t("moblie.paynowScanCodeNormal2") : ""
          }}
        </div>
        <div class="botText" v-if="languageTitle == 'English'">
          {{ $t("moblie.paynowScanCodeNormal3") }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import "@/style/moblie/reset.css";
import api from "@/api/api";
import { Notify, Toast } from "vant";
import utils from "@/utils/index";

import indexMixin from "../../mixins/index";
import themeMixin from "@/mixins/theme";

// import {Airwallex} from "airwallex-payment-elements";
// import { createElement, loadAirwallex, getElement, confirmPaymentIntent } from 'airwallex-payment-elements';

export default {
  components: {},
  data() {
    return {
      payProductH5List: [43, 32],
      language: [
        { text: "English", value: "0" },
        { text: "简体中文", value: "1" },
        { text: "Français", value: "2" },
        { text: "日本語", value: "3" },
        { text: "한국어", value: "4" }
      ],
      languageTitle: "English",
      languagekey: "0",
      showLanguageOptions: false,
      countDownList: "00:00:00",
      timeInfoFlag: false,
      dialogShow: false,
      srcPath: "payment_failure_move",
      failText: "",
      actEndTime: "",
      checkoutValue: "",
      goodInfo: {},
      queryStatusFlag: "",
      isShowPaynowSheet: false,
      paynowImg: require("../../assets/mobile/paynowLogo.png"),
      logoInfo: {
        path: "",
        name: ""
      },
      interval: null,
      returnUrl: "",
      FpxPopupShow: false,
      fpxType: "",
      fpxName: "",
      issuers: [],
      onlineBankingMalaysiaComponent: null,
      fpxPaymentMethod: null,
      highlightedIssuers: [],
      clientKey: "",
      environment: "",
      cardElement: null,
      airwallexPopupShow: false,
      airwallexResponseData: {},
      cardNumber: null,
      expiry: null,
      cvc: null,
      domElement: null,
      countryCode: "",
      clientSecret: "",
      googleOApplePayShow: false,
      payTradeNo: "",
      loading: false,
      isShowOfferBadge: true,
      bankAccountListToken: "",
      changeLanguageTimer: null,
      isQueryingOrder: false,
      isFromPayment: false,
      showReturnButton: 0,
      cancelUrl: "",
      background: "#ffaa0a",
      borderRadius: "5px",
      payWayCode: null,
      subError: false,
      failStatusInfo: "",
      // 当前支付方式信息
      currentPaymentInfo: {
        cardHolder: "张伟明",
        cardBrand: "Visa",
        cardNumber: "**** **** **** 1234",
        subscriptionName: "2025/26学年K2升小面试班",
        subscriptionPrice: "$1,200",
        nextPaymentDate: "2025年7月20日"
      }
    };
  },

  mounted() {
    this.init();
    // 上报数据
    this.reportLog({
      eventId: "PAGE_LOAD_H5",
      msg: ""
    });
  },
  computed: {},
  mixins: [indexMixin, themeMixin],
  methods: {
    // Generated by AI end
    /**
     * @method sanitizeAndValidateUrl
     * @description 清理和验证URL，处理各种可能的URL格式问题
     * @param {String} url 原始URL
     * @returns {String|null} 处理后的有效URL，如果无法修复则返回null
     */
    sanitizeAndValidateUrl(url) {
      if (!url || typeof url !== "string") {
        return null;
      }

      let processedUrl = url.trim();

      try {
        // 处理多重URL编码
        let decodedUrl = processedUrl;
        let maxDecodeAttempts = 3; // 最多尝试解码3次，防止无限循环

        for (let i = 0; i < maxDecodeAttempts; i++) {
          try {
            const decoded = decodeURIComponent(decodedUrl);
            if (decoded === decodedUrl) {
              break; // 如果解码后没有变化，说明已经完全解码
            }
            decodedUrl = decoded;
          } catch (e) {
            break; // 解码失败，使用当前结果
          }
        }

        processedUrl = decodedUrl;

        // 添加协议前缀（如果缺失）
        if (!/^https?:\/\//i.test(processedUrl)) {
          processedUrl = "https://" + processedUrl;
        } else if (processedUrl.startsWith("http://")) {
          processedUrl = processedUrl.replace("http://", "https://");
        }
        // 使用原生URL构造函数验证URL格式
        const urlObj = new URL(processedUrl);

        // 基本安全检查
        const hostname = urlObj.hostname.toLowerCase();

        // 检查是否为有效的域名格式
        const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!domainRegex.test(hostname)) {
          console.warn("Invalid domain format:", hostname);
          return null;
        }

        // 防止一些常见的恶意URL
        const blockedPatterns = [
          /^javascript:/i,
          /^data:/i,
          /^vbscript:/i,
          /^file:/i
        ];

        for (const pattern of blockedPatterns) {
          if (pattern.test(processedUrl)) {
            console.warn("Blocked potentially dangerous URL:", processedUrl);
            return null;
          }
        }
        return urlObj.toString();
      } catch (error) {
        console.warn(
          "URL validation failed:",
          error.message,
          "for URL:",
          processedUrl
        );
        return null;
      }
    },
    /**
     * @method showCloseDialog
     * @description 点击关闭按钮，跳转到 cancelUrl
     */
    showCloseDialog() {
      if (this.cancelUrl) {
        // 跳转到业务方传入的 cancelUrl
        const sanitizedUrl = this.sanitizeAndValidateUrl(this.cancelUrl);

        if (sanitizedUrl) {
          try {
            // 使用 window.open 在当前窗口跳转
            window.open(sanitizedUrl, "_self");
          } catch (error) {
            console.error("Failed to navigate to URL:", error);
            Notify({
              type: "danger",
              message: "跳转失败，URL格式错误"
            });
          }
        } else {
          // URL验证失败
          console.error("Invalid cancelUrl:", this.cancelUrl);
          Notify({
            type: "danger",
            message: "跳转失败，URL格式不正确"
          });
        }
      } else {
        // 如果没有 cancelUrl，则执行默认的返回操作
        Notify({
          type: "danger",
          message: "跳转失败，请稍后重试"
        });
      }
    },
    /**
     * @method airwallexInit
     * @param {String} airwallex支付
     * @param {String} params 支付参数
     * @description 银行支付
     */
    // initializeAirwallex() {
    //   loadAirwallex({
    //     env: 'demo', // Can choose other production environments, 'staging | 'demo' | 'prod'
    //     origin: window.location.origin, // Setup your event target to receive the browser events message
    //   }).then(() => {
    //     this.cardNumber = createElement("cardNumber");
    //     this.expiry = createElement("expiry");
    //     this.cvc = createElement("cvc");
    //     this.domElement = this.cardNumber.mount("cardNumber");
    //     this.expiry.mount("expiry");
    //     this.cvc.mount("cvc");
    //   });
    // },
    /**
     * @method handlePayment
     * @param {String} airwallex支付
     * @param {String} params 支付参数
     * @description 银行支付
     */
    // async handlePayment() {
    //   confirmPaymentIntent({
    //     element: this.cardNumber,
    //     id: "replace-with-your-intent-id",
    //     client_secret: "replace-with-your-client-secret"
    //   }).then(response => {
    //     window.alert(JSON.stringify(response));
    //   });
    // },
    /**
     * @method selectPay
     * @param {String} payCode 支付方式
     * @description 选择支付方式
     */
    selectPay(payCode, payWayCode) {
      console.log("select", payCode, payWayCode);
      this.checkoutValue = payCode;
      this.payWayCode = payWayCode;
      // 日志上报
      let params = {
        eventId: "05_02_01_00",
        msg: payCode,
        payWayCode: payWayCode
      };
      this.reportLog(params);
    },
    /**
     * @method handleLanguageChange
     * @param {string} value 语言值
     * @param {string} text 语言文本
     * @description 处理语言切换
     */
    handleLanguageChange(value, text) {
      // 直接设置语言，无需防抖
      this.languagekey = value;
      this.languageTitle = text;

      const languageMap = {
        "0": "en",
        "1": "zh",
        "2": "fr",
        "3": "ja",
        "4": "ko"
      };

      // 设置i18n语言
      this.$i18n.locale = languageMap[value];
      localStorage.setItem("lang", languageMap[value]);

      // 隐藏选项列表
      this.showLanguageOptions = false;

      // 日志上报
      let params = {
        eventId: "LANGUAGE_CHANGE_H5",
        msg: languageMap[value]
      };
      this.reportLog(params);
      this.setGoodInfo();
    },
    /**
     * @method setPayBoxH
     * @description 计算支付方式盒子的高度
     */
    async setPayBoxH() {
      this.$refs.fffContainer.style.height =
        this.$refs.moblieBox.offsetHeight -
        this.$refs.topInfo.offsetHeight +
        "px";
      console.log(
        this.$refs.moblieBox.offsetHeight,
        this.$refs.topInfo.offsetHeight,
        this.$refs.fffContainer.offsetHeight
      );
    },
    // 关闭paynow弹框
    closePayResult() {
      this.isShowPaynowSheet = false;
      this.interval && clearInterval(this.interval);
    },
    /**
     * @methods setGoodInfo
     * @description 获取页面信息
     */
    setGoodInfo() {
      let businessCode =
        utils.getUrlParmas(window.location.href).businessCode ||
        this.goodInfo.businessCode;
      let checkoutToken = utils.getUrlParmas(window.location.href)
        .checkoutToken;
      let ua = navigator.userAgent.toLowerCase();
      let merchantCode =
        utils.getUrlParmas(window.location.href).merchantCode ||
        this.goodInfo.merchantCode;
      let merchantStageNo =
        utils.getUrlParmas(window.location.href).merchantStageNo ||
        this.goodInfo.merchantStageNo;
      let checkoutType =
        utils.getUrlParmas(window.location.href).checkoutType || 0;

      let params = {
        businessCode: businessCode,
        merchantCode: merchantCode,
        merchantStageNo: merchantStageNo,
        checkoutType: checkoutType
      };

      // 处理showReturnButton参数，添加更好的容错处理
      const showReturnButtonStr = utils.getUrlParmas(window.location.href)
        .showReturnButton;
      console.log("H5原始showReturnButton值:", showReturnButtonStr);

      // 如果获取到的值是字符串"1"或数字1，则为1，否则为0
      if (showReturnButtonStr === "1" || showReturnButtonStr === 1) {
        this.showReturnButton = 1;
      } else if (showReturnButtonStr === "0" || showReturnButtonStr === 0) {
        this.showReturnButton = 0;
      } else {
        // 尝试转换为数字，如果NaN则默认为0
        const parsed = parseFloat(showReturnButtonStr);
        this.showReturnButton = isNaN(parsed) ? 0 : parsed;
      }

      console.log("H5解析后的showReturnButton:", this.showReturnButton);
      this.cancelUrl = utils.getUrlParmas(window.location.href).cancelUrl || "";
      // Generated by AI end

      // 微信环境下增加env参数
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        params["env"] = 1;
      }
      this.reportLog({
        eventId: "05_01_01_00",
        msg: params
      });
      const loading = Toast.loading({
        message: this.$i18n.t("common.loadingCommonText"),
        forbidClick: true,
        duration: 0
      });
      api.apiMethod.subscriptionCheckoutShow
        .post(params, {
          checkoutToken: checkoutToken,
          timezone: this.getTimeZone()
        })
        .then(res => {
          // 指定关闭某一个loading
          loading.clear();
          if (res.data.code === 10000) {
            this.reportLog({
              eventId: "05_01_02_00",
              msg: res.data.subMsg
            });
            res.data.data.payWayConfigList =
              this.payWayConfigList(
                res.data.data.payWayConfigList,
                this.payProductH5List
              ) || [];
            this.goodInfo = res.data.data;
            // 显示优惠角标的条件：后端返回 specialOffer/promoTag 为真，或 thereafterFee 存在
            // this.isShowOfferBadge = Boolean(this.goodInfo.specialOffer || this.goodInfo.promoTag || this.goodInfo.thereafterFee);
            if (this.goodInfo.payWayConfigList) {
              this.goodInfo.payWayConfigList.map(item => {
                // if (item.checked && item.platformType === 0) {
                //   this.checkoutValue = item.payProduct;
                // }
                // 如果是fpx支付，payProduct=46
                console.log(item.curPayProductData, "item.curPayProductData");
                if (item.curPayProductData.productCode === 46) {
                  this.issuers = item.curPayProductData.issuers;
                  this.fpxType = item.curPayProductData.type;
                  this.fpxName = item.curPayProductData.name;
                  this.clientKey = item.curPayProductData.adyenClientKey;
                  console.log(this.clientKey, "this.clientKey");
                  // 将clientKeyy以'_''分割，取第一个值
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                }
                // 如果是ach支付，payProduct=61
                if (item.curPayProductData.productCode === 61) {
                  this.bankAccountListToken =
                    item.curPayProductData.bankAccountListToken;
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                  this.clientKey = item.curPayProductData.adyenClientKey;
                }
              });
            }
            // 开始轮询查询订单状态，但不显示loading（仅在从ACH支付返回时才显示loading）
            this.subscriptionQueryOrder(false);
            // let nowTime =
            //   Math.abs(new Date().getTime() - this.goodInfo.nowTime) > 3000
            //     ? this.goodInfo.nowTime
            //     : new Date().getTime();
            if (this.goodInfo.timeOut) {
              this.timeInfoFlag = true;
              // timeOut直接为剩余的时间
              this.countDown(this.goodInfo.timeOut);
            } else {
              // 订单超时
              this.subStatusResult(3, res.data);
            }
            // 开启轮询
            this.subscriptionQueryOrder();
            this.setPayBoxH();
            // 上报数据
            let logParams = {
              eventId: "CONFIGSUCCESS_H5"
            };
            this.reportLog(logParams);
          } else {
            this.subError = true;
            this.dialogShow = true;
            console.log(this.subError, "this.subError======");
            this.failStatusInfo = res.data.subMsg;
            // 跳入到错误页，并将错误信息传递给错误页
            this.$router.push({
              path: "/error",
              query: { msg: res.data.subMsg }
            });
            Notify({ type: "warning", message: res.data.subMsg });
            let logParams = {
              eventId: "CONFIGFAIL_H5"
            };
            this.reportLog(logParams);
          }
        });
    },

    // subStatusResult 订阅状态结果
    subStatusResult(status) {
      // 2不做处理 1-6进成功页面 7超时
      if (status === 2) {
        let params = {
          eventId: "SUBSCRIPTION_SUCCESS",
          msg: this.returnUrl
        };
        this.reportLog(params);
      } else if (status === 7) {
        this.timeInfoFlag = false;
        this.reportLog({
          eventId: "05_06_01_00",
          msg: this.returnUrl
        });
        // 超时
        console.log(this.$i18n.locale, "this.$i18n.locale ====3");
        this.dialogShow = true;
        this.srcPath = "order_invalid_move";
        this.failStatusInfo =
          this.$i18n.locale === "en"
            ? "The order has expired. Please make a new order."
            : this.$i18n.locale === "zh"
            ? "订单已过期，请重新下单"
            : this.$i18n.locale === "fr"
            ? "La commande a expiré. Veuillez passer une nouvelle commande."
            : this.$i18n.locale === "ja"
            ? "注文が期限切れになりました。新しい注文をしてください。"
            : this.$i18n.locale === "ko"
            ? "주문이 만료되었습니다. 새 주문을하십시오."
            : "订单已过期，请重新下单";
      } else {
        let params = {
          eventId: "SUBSCRIPTION_APPLY",
          msg: this.returnUrl
        };
        this.reportLog(params);
        window.location.href =
          utils.getUrlParmas(window.location.href).returnUrl || "";
      }
    },
    /**
     * @method goPay
     * @description 点击支付
     */
    goPay() {
      // Generated by AI start - Cursor - 2024-12-19
      let businessCode =
        utils.getUrlParmas(window.location.href).businessCode ||
        this.goodInfo.businessCode;
      let checkoutToken = utils.getUrlParmas(window.location.href)
        .checkoutToken;
      // Generated by AI end
      this.reportLog({
        eventId: "05_03_01_00",
        msg: this.checkoutValue
      });
      if (!this.checkoutValue) {
        Notify({ type: "warning", message: this.$i18n.t("common.payMethods") });
      } else {
        Toast.loading({
          message: this.$i18n.t("common.payingText"),
          forbidClick: true,
          duration: 0
        });
        api.apiMethod.subscriptionCheckoutPay
          .post(
            {
              checkoutType: 0,
              businessCode: businessCode,
              merchantCode: this.goodInfo.merchantCode,
              merchantStageNo: this.goodInfo.merchantStageNo,
              productCode: this.checkoutValue,
              payWayCode: this.payWayCode,
              // Generated by AI start - Cursor - 2024-12-19
              merchantPayNo: utils.getUrlParmas(window.location.href)
                .merchantPayNo,
              // Generated by AI end
              extendParam: this.extendParam,
              env: "01"
              // ip: this.checkoutValue === 3 ? "127.0.0.1" : ""
            },
            {
              checkoutToken: checkoutToken
            }
          )
          .then(res => {
            if (res.data.code === 10000) {
              this.reportLog({
                eventId: "05_03_02_00",
                payCode: this.checkoutValue,
                msg: res.data.subMsg
              });
              console.log(res.data, "==res.data==");
              this.subscriptionQueryOrder(true);
              Toast.clear();
              // 支付宝支付
              switch (this.checkoutValue) {
                case 43: {
                  // 2 跳转内容 url 非2成功
                  if (res.data.data.status === 2) {
                    let url = JSON.parse(res.data.data.subscriptionData).url;
                    window.location.href = url;
                  } else {
                    let url =
                      utils.getUrlParmas(window.location.href).returnUrl || "";
                    window.location.href = url;
                  }
                  Toast.clear();
                  this.reportLog({
                    eventId: "05_04_01_00",
                    msg: res.data.subMsg
                  });
                  // 开启轮询
                  this.subscriptionQueryOrder();
                  break;
                }
                case 32: {
                  this.reportLog({
                    eventId: "05_04_01_00",
                    msg: res.data.subMsg
                  });
                  let url = JSON.parse(res.data.data.subscriptionData).url;
                  window.location.href = url;
                  Toast.clear();
                  // 开启轮询
                  this.subscriptionQueryOrder();
                  break;
                }
                default:
                  break;
              }
            } else {
              Toast.clear();
              this.subStatusResult(7);
            }
          });
      }
    },
    closeDialog() {
      this.dialogShow = false;
      // 如果是超时,且url参数有cancelUrl
      if (
        !this.timeInfoFlag &&
        utils.getUrlParmas(window.location.href).cancelUrl
      ) {
        window.location.href = utils.getUrlParmas(
          window.location.href
        ).cancelUrl;
      }
    },
    init() {
      this.setGoodInfo();
      // 获取本地存储的语言，默认为英语
      const storedLang = localStorage.getItem("lang") || "en";

      // 根据本地存储的语言设置当前语言
      if (storedLang === "en") {
        this.languageTitle = "English";
        this.$i18n.locale = "en";
        this.languagekey = "0";
      } else if (storedLang === "zh") {
        this.languageTitle = "简体中文";
        this.$i18n.locale = "zh";
        this.languagekey = "1";
      } else if (storedLang === "fr") {
        this.languageTitle = "Français";
        this.$i18n.locale = "fr";
        this.languagekey = "2";
      } else if (storedLang === "ja") {
        this.languageTitle = "日本語";
        this.$i18n.locale = "ja";
        this.languagekey = "3";
      } else if (storedLang === "ko") {
        this.languageTitle = "한국어";
        this.$i18n.locale = "ko";
        this.languagekey = "4";
      }

      // 自动关闭语言选择器下拉菜单的点击事件
      document.addEventListener("click", this.handleDocumentClick);
      // Generated by AI start - Cursor - 2024-12-19
      // 获取背景色
      this.background =
        utils.getUrlParmas(window.location.href).background || "#ffaa0a";
      // 获取圆角
      this.borderRadius =
        utils.getUrlParmas(window.location.href).borderRadius || "5px";
      // Generated by AI end
    },

    // 处理文档点击事件关闭语言选择器
    handleDocumentClick(event) {
      const selector = document.querySelector(".mobile-language-selector");
      if (selector && !selector.contains(event.target)) {
        this.showLanguageOptions = false;
      }
    },
    isInWeixin() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeDestroy() {
    // 移除各种事件监听器，防止内存泄漏
    document.removeEventListener("click", this.handleDocumentClick);
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>
<style lang="less">
.moblieContent {
  background: #f6f6f6;
  width: 100%;
  height: 100%;
  position: relative;
  .payBtnBox {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.16rem 0.4rem;
    background: #fff;
    box-shadow: 0px -6px 10px 0px rgba(0, 0, 0, 0.08);
    .payBtn {
      width: 100%;
      height: 0.88rem;
      text-align: center;
      line-height: 0.88rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: #ffaa0a;
      border-radius: 0.44rem;
    }
  }
  .moblieBox {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 1.2rem;
    box-sizing: border-box;
    // background: #fff;
    overflow: hidden;
    .line {
      height: 0.2rem;
      background: rgba(248, 248, 248, 1);
    }
    .topInfo {
      position: relative;
      // background: #fff;
      .title {
        text-align: center;
        background: #fff;
        font-size: 0.36rem;
        height: 1rem;
        line-height: 1rem;
        font-weight: 400;
        color: #333; // 原先为白色，调整为深色以适配白底顶部
      }
      .div_shown_close_button {
        position: absolute;
        left: 10px;
        top: 10px;
        z-index: 10;

        .div_close_button {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 10px;
          background: rgba(0, 0, 0, 0.06);
          transition: all 0.2s;

          &:hover {
            background: rgba(0, 0, 0, 0.1);
          }

          .close-icon {
            color: #333;
            font-size: 10px;
            font-weight: bold;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .div_select_right {
        position: absolute;
        right: 10px;
        top: 14px;
        .mobile-language-selector {
          position: relative;
          width: 100px;

          .selected-language {
            padding: 5px 10px;
            border-radius: 8px;
            background: #f9f9fa;
            color: #44454c;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            i {
              margin-left: 5px;
            }
          }

          .language-options {
            position: absolute;
            right: 0;
            top: 110%;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            z-index: 100;
            min-width: 120px;

            .language-option {
              padding: 10px 15px;
              cursor: pointer;
              text-align: center;
              transition: all 0.2s;

              &:hover {
                background: #f5f5f5;
              }

              &.active {
                background: #f5f5f5;
                color: #333;
              }
            }
          }
        }
      }
      .changeLangBtn {
        i {
          display: inline-block;
          position: absolute;
          top: 0.1rem;
          left: 0.16rem;
          width: 0.36rem;
          height: 0.36rem;
          background-image: url("../../assets/mobile/switch_icon.png");
          background-size: cover;
        }
        position: absolute;
        right: 0;
        top: 0.22rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 1rem 0 0 1rem;
        height: 0.28rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        padding: 0.14rem 0.3rem 0.14rem 0.6rem;
      }
      .amountInfo {
        text-align: center;
        margin: 16px;
        padding: 12px 0 12px;
        background: #fff;
        border-radius: 8px;
        color: #333; // 顶部信息改为深色
        .subscription-card {
          width: calc(100% - 0.48rem);
          margin: 0 auto;
          // padding: 0.36rem 0.28rem 0.32rem;
          background: #fff; // 白底卡片
          color: #333;
          text-align: center; // 居中排列
          // display: flex;
          align-items: center;
          .sub-error-container {
            margin-left: 8px;
            flex: 1; // 允许文本容器自适应宽度
            min-width: 0; // 允许内容缩小
          }
        }
        .header-row {
          display: flex;
          align-items: flex-start;
          // justify-content: center;
          gap: 0.12rem;
          margin-bottom: 5px;
        }
        .success-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #ffaa0a; // 黄色圆形
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff; // 白色对勾
          font-size: 16px;
          min-width: 24px;
          margin: 3px 0 0 0; // 移除原有的 margin
          .check {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            line-height: 1;
            svg {
              display: block;
              margin-top: -1px; // 微调向上移动1px
            }
          }
        }
        .subscription-title {
          font-size: 16px;
          font-weight: bold;
          color: #44454c; // 深色标题
          line-height: 1.3;
          text-align: left;
          margin: 0; // 移除原有的 margin
        }
        .subscription-subtitle {
          text-align: left;
          font-size: 0.28rem;
          color: #44454c; // 深色副标题
          margin-top: 20px;
          line-height: 1.4;
        }
        .countdown {
          text-align: left;
          font-size: 0.26rem;
          color: #666; // 普通文案深色
          // margin-top: 0.24rem;
          line-height: 1.4;
          margin-left: 30px;
          .time {
            color: #ffaa0a; // 仅时间高亮为橙色
            font-weight: 700;
            margin: 0 0.06rem;
          }
        }
        .moneyInfo {
          .currency {
            font-size: 0.32rem;
            vertical-align: middle;
            margin-right: 0.08rem;
          }
          .totalfee {
            font-weight: 600;
          }
          vertical-align: middle;
          display: inline-block;
          font-size: 0.48rem;
        }
        .timeInfo {
          span {
            display: inline-block;
            margin-right: 0.12rem;
          }
          margin-top: 0.3rem;
          font-size: 0.28rem;
          font-weight: 400;
        }
      }
      .botLine {
        width: 100%;
        position: absolute;
        bottom: -0.03rem;
        left: 0;
        height: 0.3rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.3rem 0.3rem 0 0;
      }
    }
    .fffContainer {
      overflow: auto;
    }
    .fffContainer::-webkit-scrollbar {
      display: none;
    }
    /* 新增：子收银台信息模块样式 */
    .subCheckoutContainer {
      padding: 12px;
      margin: 0px 16px 16px;
      border-radius: 8px;
      background: #fff;
      .sub-card {
        background: #fff;
        // padding: 0.28rem 0.24rem 0.24rem;
      }
      .row-item {
        margin-bottom: 16px;
        .row-label {
          font-size: 14px;
          color: #8f8f94;
          margin-bottom: 0.1rem;
        }
        .row-value {
          font-size: 0.32rem;
          color: #333;
          line-height: 1.6;
          word-break: break-all;
          &.order-no {
            word-break: break-all;
            font-size: 0.3rem;
            color: #44454c;
          }
          &.product-name {
            font-weight: 500;
          }
        }
      }
      .divider {
        height: 1px;
        background: #eee;
        margin: 16px 0 16px;
      }
      .section-title {
        font-size: 14px;
        font-weight: 700;
        color: #8f8f94;
        margin-bottom: 0.18rem;
      }
      .subscription-box {
        background: #f7f7f7;
        border-radius: 12px;
        padding: 0.26rem 0.22rem 0.2rem;
        .sub-line {
          font-size: 14px;
          color: #44454c;
          line-height: 0.46rem;
          display: flex;
          align-items: flex-start;
          .label {
            flex: 1;
            margin-right: 0.12rem;
            color: #44454c;
            word-break: break-word;
            overflow-wrap: anywhere;
            white-space: normal;
          }
          .content {
            flex: 1;
            color: #44454c;
            word-break: break-word;
            overflow-wrap: anywhere;
          }
          &:not(:last-child) {
            margin-bottom: 0.1rem;
          }
        }
        .price-row {
          display: flex;
          align-items: center;
          margin-top: 0.16rem;
          flex-wrap: wrap;
          .currency {
            font-size: 0.32rem;
            color: #ff7a00;
            margin-right: 0.06rem;
          }
          .totalfee {
            font-size: 0.52rem;
            font-weight: 700;
            color: #ff7a00;
            margin-right: 2px;
          }
          .offer-badge {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 90px;
            height: 18px;
            padding: 0; /* 为左侧尖角留出空间 */
            color: #fff;
            border-radius: 9px;
            font-size: 10px;
            font-weight: 700;
            line-height: 19px;
            vertical-align: middle;
            background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="90" height="18" viewBox="0 0 90 18" fill="none"><path d="M2.99993 4.00001C2.99993 1.79087 4.79079 0 6.99993 0H85.9999C88.2091 0 89.9999 1.79086 89.9999 4V14C89.9999 16.2091 88.2091 18 85.9999 18H6.99993C4.79079 18 2.99993 16.2091 2.99993 14C2.99993 12.741 2.40717 11.5554 1.39996 10.8L1.13328 10.6C0.0666355 9.79999 0.0666343 8.20001 1.13328 7.40001L1.39996 7.2C2.40717 6.44458 2.99993 5.25903 2.99993 4.00001Z" fill="%23FA6000"/></svg>')
              no-repeat center/cover;
            white-space: nowrap;
          }
        }
        .thereafter {
          width: 100%;
          margin-top: 0.06rem;
          line-height: 20px;
          font-size: 0.26rem;
          color: #999;
        }
      }
    }
    // 新增：换卡页面样式
    .changeCardBox {
      padding: 12px;
      margin: 0px 16px 16px;
      border-radius: 8px;
      background: #fff;

      .current-payment-section {
        .payment-card {
          background: #fff;

          .card-content {
            display: block; // 移动端改为垂直布局
            margin-bottom: 24px;

            .card-left,
            .card-right {
              margin-bottom: 20px;
            }

            .card-right {
              margin-left: 0; // 移除PC端的左边距
            }

            .payment-method-label,
            .card-holder-label,
            .card-brand-label,
            .card-number-label {
              font-size: 0.26rem; // 使用移动端字体单位
              color: #8f8f94;
              margin-bottom: 4px;
              line-height: 1.4;
            }

            .payment-method-value,
            .card-holder-value,
            .card-brand-value,
            .card-number-value {
              font-size: 0.3rem; // 使用移动端字体单位
              color: #333;
              font-weight: 500;
              margin-bottom: 16px;
              line-height: 1.4;
            }
          }

          .subscription-info {
            .subscription-title {
              font-size: 0.3rem; // 使用移动端字体单位
              color: #333;
              font-weight: 500;
              margin-bottom: 12px;
            }

            .subscription-info-content {
              background-color: #f5f5f5;
              border-radius: 8px;
              padding: 12px;

              .subscription-details {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;

                .subscription-name {
                  font-size: 0.32rem; // 使用移动端字体单位
                  color: #333;
                  font-weight: 600;
                  flex: 1;
                  line-height: 1.4;
                }

                .subscription-price {
                  font-size: 0.4rem; // 使用移动端字体单位
                  color: #ff7928;
                  font-weight: 700;
                  white-space: nowrap;
                }
              }

              .next-payment {
                font-size: 0.26rem; // 使用移动端字体单位
                color: #666;
                line-height: 1.4;

                .next-payment-label {
                  margin-right: 8px;
                }

                .next-payment-date {
                  color: #333;
                  font-weight: 500;
                }
              }
            }
          }
        }
      }
    }
    .goodInfo {
      padding: 0.1rem 0.4rem 0.4rem;
      background-color: #fff;
      font-weight: 400;
      .title {
        font-size: 0.28rem;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 0.2rem;
      }
      .goodName,
      .goodDes {
        font-size: 0.32rem;
        color: rgba(51, 51, 51, 1);
        line-height: 0.48rem;
      }
      .goodName {
        margin-bottom: 0.4rem;
      }
    }
    .payMethod {
      padding: 12px;
      margin: 0px 16px 16px;
      border-radius: 8px;
      background-color: #fff;
      font-weight: 400;
      font-size: 0.28rem;
      color: rgba(102, 102, 102, 1);
      .title {
        margin-bottom: 0.4rem;
      }
      .resultText {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 20px;

        .result-icon {
          margin-bottom: 12px;
          img {
            width: 40px;
            height: 40px;
          }
        }

        .result-message {
          font-size: 0.28rem;
          color: rgba(51, 51, 51, 1);
          line-height: 1.4;
        }
      }
      .payAll {
        width: 100%;
        .tip {
          color: #969799;
          font-size: 12px;
          line-height: 18px;
          padding-right: 0.8rem;
        }
      }
      .payPart {
        display: flex;
        align-items: center;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        // height: 0.68rem;
        padding: 0.1rem 0;
        i {
          display: inline-block;
          height: 0.68rem;
          margin-right: 0.2rem;
          img {
            height: 100%;
            vertical-align: middle;
          }
        }
        .text {
          display: block;
          .van-cell {
            padding: 0 !important;
            font-size: 0.28rem;
            font-weight: 400;
            // height: 0.68rem;
            line-height: 1.2;
          }
        }
      }
      .radioBox {
        .van-radio__icon--checked .van-icon {
          background-color: var(--theme-color, #ffaa0a) !important;
          border-color: var(--theme-color, #ffaa0a) !important;
        }
      }
    }

    .dialogBox {
      width: 5.9rem;
      text-align: center;
      border-radius: 0.12rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
        display: block;
        margin: 0.5rem auto 0.2rem;
      }
      p {
        padding: 0 50px;
      }
      .van-dialog__content {
        margin-bottom: 0.5rem;
      }
      .van-dialog__footer {
        border-top: 0.01rem solid rgba(226, 226, 226, 1);
        .van-button__text {
          font-weight: 600;
        }
      }
    }
  }
  .paynow-action-sheet {
    .header {
      box-sizing: border-box;
      height: 1rem;
      background: #f8f8f8;
      padding: 0 0.3rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 1rem;
      .div_left {
        float: left;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        img {
          vertical-align: middle;
          margin-right: 12px;
        }
      }
      .div_right {
        float: right;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-top: 2px;
          cursor: pointer;
          background: url("../../assets/pc/fork_popup.svg") no-repeat;
          background-size: 100%;
        }
        span:hover {
          background: url("../../assets/pc/fork_popup_hower.svg") no-repeat;
          background-size: 100%;
        }
      }
    }
    .centerContent {
      text-align: center;
      padding-top: 0.38rem;
      padding-bottom: 0.6rem;
      .botText {
        text-align: center;
        font-size: 0.28rem;
        font-weight: 400;
        color: #333;
        line-height: 0.4rem;
        padding: 0 0.5rem;
        & + .botText {
          margin-top: 0;
        }
        span {
          font-weight: 500;
          color: #ffaa0a;
        }
      }
      .save-button {
        width: 3rem;
        height: 0.88rem;
        border-radius: 0.14rem;
        border: 1px solid #ffaa0a;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffaa0a;
        background: #fff;
        margin: 23px 0 30px;
      }
    }
  }
}
.popup-content {
  padding: 0.2rem 0.4rem 0.5rem;
  .popup-title {
    font-size: 0.32rem;
    font-weight: 600;
    color: #333;
    line-height: 0.44rem;
    padding: 0.3rem 0;
    text-align: center;
  }
}
.adyen-checkout__content-separator,
#molpay_ebanking_fpx_MY-container .adyen-checkout__field {
  display: none;
}
.adyen-checkout__issuer-button-group {
  display: block !important;
  .adyen-checkout__issuer-button {
    width: 100%;
    border: none !important;
    box-shadow: none !important;
    border-bottom: 1px solid #e2e2e2 !important;
    border-radius: 0 !important;
    height: 56px !important;
    .adyen-checkout__issuer-button-img {
      max-height: 20px;
    }
    .adyen-checkout__issuer-button-text {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .adyen-checkout__issuer-button--selected {
    color: #ffaa0a !important;
  }
}

.airwallex-popup-content {
  padding: 1.2rem 0.4rem 0.5rem;
}
.googleOrApplePayButton {
  width: 260px;
  height: 40px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  margin: 32px auto 0;
}
.googleOrApplePayButton-wrap {
  flex-wrap: wrap;
  padding-top: 40px;
  text-align: center;
  .tips {
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }
}
.loading-img {
  width: 30px;
  height: 30px;
  margin: 32px auto 0;
  -webkit-transform: rotate(360deg);
  animation: rotation 2s linear infinite;
  -moz-animation: rotation 2s linear infinite;
  -webkit-animation: rotation 2s linear infinite;
  -o-animation: rotation 2s linear infinite;
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
